interface IInputProps {
  name: string;
  className?: string;
  placeholder?: string;
}

export const InputBasic = ({ name, className = '', placeholder = 'Type here...' }: IInputProps) => (
  <input
    type="text"
    name={name}
    placeholder={placeholder}
    className={`${className} text-gray-400 bg-gray-800 px-4 py-[10px] rounded`}
  />
);
